import { HttpService } from "./http.service";
import { ResultRequestModel } from "../models/resultRequest.model";

const basePath = "/EquipmentPickupDateHistoryBySsp";
const request = HttpService.handleRequest();

export const EquipmentPickupHistoryService = {
  getLatestPickupCasheChangeDateByEquipment,
  GetNextPickupDatesByEquipment, 
  getLatestPickupDateByEquipmentFlagPickup
};

// Método original - retorna apenas a última data
// Método original - retorna apenas a última data (com flag_cash_change)
async function getLatestPickupCasheChangeDateByEquipment(equipmentId: number): Promise<ResultRequestModel> {
  return request.get(`${basePath}/GetLatestPickupDateCasheChangeByEquipment/${equipmentId}`);
}

// Novo método - retorna firstDate e secondDate
async function GetNextPickupDatesByEquipment(equipmentId: number): Promise<ResultRequestModel> {
  return request.get(`${basePath}/GetNextPickupDatesByEquipment/${equipmentId}`);
}

// Novo método - busca a última data onde flag_pickup = true
async function getLatestPickupDateByEquipmentFlagPickup(equipmentId: number): Promise<ResultRequestModel> {
  return request.get(`${basePath}/GetLatestPickupDateByEquipmentFlagPickup/${equipmentId}`);
}


export default EquipmentPickupHistoryService;
